let ques = [
  {
    类型: '托福',
    题目: 'University students should be required to take history courses no matter what field they study.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'A low-paid but secure job is better than a job with a high salary but easy to lose.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Governments should focus its budget more on art museums and concert halls than on recreational facilities such as swimming pools and playground.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'A government should focus its budget more on young children education than on universities.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Governments should spend more money on environment protection than on economic development.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People are now easier to become educated than in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In twenty years, there will be fewer cars in use than in today.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People in the past were easier to be happy and satisfied than they are today.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Advertisements make the products seem better than they really are.',
    备注: '',
  },
  {
    类型: '托福',
    题目: "Technology makes people's lives simpler in turn to make people's lives more complicated.",
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Movies and television have more negative effects than positive effects on young people. 13.People who',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People today will be happier if they have fewer possessions.',
    备注: '',
  },
  {
    类型: '托福',
    题目: "Successful people take new things and take risks rather than the thing that they've done well.",
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People who keep their room clean and tidy are more likely to be successful in the future.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Future career success relies more on other people more than studying hard at school. 19.Only movies t',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Now we have too many sources of news and information that we cannot tell who is telling the truth.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'If parents want their children to perform well at school, they should limit their children’s time on',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People today can solve many important problems so they do not need help from the government.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'At university and colleges, sports and social activities are just as important as classes and libraries and should receive equal financial support.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Always telling the truth is the most important consideration in any relationship between people.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is more important to keep your old friends than it is to make new friends.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In twenty years, there will be fewer cars in use than there are today.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People today spend too much time on personal enjoyment. Doing things they like to do rather than doing things they should do.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Life today is easier and more comfortable than it was when your grandparents were children.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is more important for students to understand ideas and concepts than it is for them to learn facts.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Television advertising directed toward young children (aged two to five) should not be allowed.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Technology has made children less creative than they were in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Playing computer games is a waste of time. Children should not be allowed to play them.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Some people say that the internet provides people with a lot of valuable information. Others think access to so much information creates problems. Which view do you agree with?',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is better to have broad knowledge of many academic subjects than to specialize in one specific subject.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The extended family (grandparents, cousins, aunts and uncles) is less important now than it was in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People benefit more from travelling in their own country than from travelling to foreign countries.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In order to become financially responsible adults, children should learn to manage their own money at a young age.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The best way to travel is in a group led by a tour guide.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Most advertisements make products seem much better than they really are.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Students are more influenced by their teachers than by their friends.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In order to be well-informed, a person must get information from many different news sources.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Successful people try new things and take risks rather than only doing what they already know how to do well.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'For success in a future job, the ability to relate well to people is more important than studying hard in school.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Teachers should not take their social or political views known to stdents in the classroom.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In today’s world, it is more important to work quickly and risk making mistakes than to work slowly and make sure that everything is correct.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'One of the best ways that parents can help their teenage children prepare for adult life is to encourage them to take a part-time job.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Young people nowadays do not give enough to helping their communities.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is better for children to choose jobs that are similar to their parents’ jobs than to choose jobs that are very different from their parents’ jobs.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'If people have the opportunity to get a secure job, they should take it right away rather than wait for a job that would be more satisfying.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Parents today are more involved in their children’s education than were parents in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'To improve the quality of education, universities should spend more money on salaries for university professors.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is more enjoyable to have a job where you work only three days a week for long hours than to have a job where you work five days a week for shorter hours.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Because the world is changing so quickly, people now are less happy or less satisfied with their lives than people were in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Young people today have no influence on the important decisions that determine the future of society as a whole.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'When teachers assign projects on which students must work together, the students learn much more effectively than when they are asked to work alone on projects.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Educating children is a more difficult task today than it was in the past because they spend so much time on cell phone, online games, and social networking web site.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People learn things better from those at their own level—such as fellow students or co-workers—than from those at a higher level, such as teachers or supervisors.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'A person should never make an important decision alone.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Some people think university professors should spend more time doing research while others think they should spend more',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree the following statement? The rapid growth of cities today should have a positive effect of the',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement? Because the world is changing quickly, people now are less happy',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the parents should let children make mistakes and let them learn from their own mistakes?',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Young people have no influence on important decisions that determine the future of society as a whole',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with: In order to become financially responsible adults, children should manage their own mone',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People who go outside are more successful and happier than people who stay in village.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The government should support scientific research that does not have any practical use.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People holding different views can not achieve success as a team.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'All high school students should take basic economic courses.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Which is better - challenging plans about one’s future or practical plans about one’s future?',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'If parents want their children to do well at school, they should limit the time their children spend on watching TV.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People should solve important problems by themselves or with the help from their family members so there’s no need for government t',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'In order to make ourselves happy, we should learn how to make others happy first.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Working at home using computers or telephones is better than working in the office',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People should take a secure job immediately when finding one instead of waiting for the job that they find more satisfying.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The way a person is dressed is good indication of his/her character or personality',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People should have hobbies and do physical activities that are very different from their own work.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'If you need to discuss upsetting or controversial problems with others, will you use email/text messaging or use telephone/voice mes',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is more likely for people with skills to succeed.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The best way for parents to teach their children about responsibility is to have them care for animals',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Many countries are paying attention to environmental problems. But attention is not making the environmental situation better.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'We need to have different sources of news and information to know which one is the real or who is telling the truth.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The personal and work-related challenges that young people face today are not any different from the challenges their parents and gr',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Spending money on their pets. Even though there can be other good ways to spend money.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'People care more about public recognition than about money. Even if no more money is given, public recognition can still make people',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Parents today are more involved in their children’s education than parents were in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Compared with people who live in urban areas, the people who live in rural areas can take better care of their families.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'The advice from the grandparents is of no use to their grandchildren because the world has changed a lot over the past 50 years.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is easier for parents to raise their children now than 50 years ago.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'To improve the quality of education, universities should share more money on professors’ salaries.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'It is more enjoyable to have a job and work long hours for three days in a week than to work shorter hours for give days in a week.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Two people can still become friends if one of them has more money than the other one does.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Some people think university professors should spend more time doing research while others think they should spend more time educating students. What is your view?',
    备注: '2011年',
  },
  {
    类型: '托福',
    题目: "Do you agree or disagree the following statement？The rapid growth cities today's should have a positive effect of the development of the society.",
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement? Because the world is changing so quickly, people now are less happy and less satisfied than people in the past.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the parents should let children make mistake and let them learn from their own mistake.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Young people have no influence on important decisions that determine the future of society as a whole',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement: In order to become financially responsible adults, children should manage their own money at the young age.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:People who go outside are more successful and happier than people who stay in villages.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:The government should support scientific research that does not have any practical use.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:People holding different views cannot achieve success as a team.',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:All high-school students should take basic economic courses.',
    备注: '',
  },
  {
    类型: '托福',
    题目: "Which is better, challenging plans about one's future or practical plans about one's future?",
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement: If parents want their children to do well at school, they should limit the time their children spend on watching TV.',
    备注: '',
  },
  {
    类型: '托福',
    题目: "Do you agree or disagree with the following statement: People can solve important problems by themselves or with the help from their family members so there's no need for the government to help them.",
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:In order to make ourselves happy, we should learn how to make others happy first.( 与3月27日大陆重题，这是2008年1月以来的第7次同周末重题）',
    备注: '',
  },
  {
    类型: '托福',
    题目: 'Do you agree or disagree with the following statement:People should have hobbies and do physical activities that are very different from their own work.',
  },
]
export default ques
